<template>
  <div class="create-container">
    <main>
      <div class="header">
        <router-link to="/" class="float-left"
          ><img src="/src/assets/back.png" class="header-icon" style="visibility: hidden"
        /></router-link>
        <span v-on:click="gotoHome">
          <span class="header1">BITMAX&nbsp;</span>
          <span class="header2">마음의소리</span>
        </span>
        <router-link to="/create" class="float-right"
          ><img src="/src/assets/images/create.png" class="header-icon" style="visibility: hidden" />
        </router-link>
      </div>

      <div class="create-btn">
        <div v-if="article == undefined">
          <!-- 닫기 -->
          <img src="../../../src/assets/images/close.png" class="close" v-on:click="gotoList" />
          <!-- 글쓰기 -->
        </div>
        <div v-else>
          <img src="../../../src/assets/images/close.png" class="close" v-on:click="backtoArticle" />
          <!-- 수정 -->
        </div>
        <div></div>
        <div v-if="article == undefined">
          <!-- 등록 -->
          <img src="../../../src/assets/images/write.png" class="write" v-on:click="createArticle" />
        </div>
        <div v-else>
          <img src="../../../src/assets/images/write.png" class="write" v-on:click="alterArticle" />
        </div>
      </div>

      <div v-if="article == undefined">
        <!-- 글쓰기 -->
        <TextareaAutosize
          v-model="newArticle.content"
          class="content"
          placeholder="내용을 입력하세요"
          autofocus
        ></TextareaAutosize>
      </div>
      <div v-else>
        <!-- 수정 -->
        <TextareaAutosize
          type="text"
          v-model="article.content"
          class="content"
          :min-height="300"
          :max-height="1000"
          autofocus
        >
        </TextareaAutosize>
      </div>

      <modal-component title="내용을 입력하세요" :commentID="0" :show="show" @close="show = false"></modal-component>
      <modal-component
        title="1000자 이하로 입력하세요"
        :commentID="0"
        :show="show2"
        @close="show2 = false"
      ></modal-component>
    </main>
  </div>
</template>

<script>
import firebase from 'firebase/app';
// import {userId} from '../../const'
import { getTimeStamp } from '../../api';
import Modal from '../modal/Modal';

export default {
  name: 'Create',
  components: {
    'modal-component': Modal,
  },
  data: function() {
    return {
      newArticle: {
        userId: '',
        content: '',
        createDT: getTimeStamp(),
        updateDT: getTimeStamp(),
        like: 0,
        unLike: 0,
        token: '',
      },
      show: false,
      show2: false,
      article: this.$route.params.article,
      alarmList: [],
    };
  },
  watch: {
    $route: function(to) {
      //to가 내가 앞으로 갈곳 from이 지금 있는 곳
      this.newArticle = {};
      this.article = to.params.article;
    },
  },
  mounted() {
    // this.getIpClient();
    this.newArticle = {};
  },
  methods: {
    gotoHome() {
      this.$router.push({ name: 'Home' });
    },
    createArticle: function() {
      if (this.newArticle.content == '' || this.newArticle.content == undefined) {
        this.show = true;
      } else {
        if (this.newArticle.content.length > 1000) {
          this.show2 = true;
        } else {
          this.newArticle.createDT = getTimeStamp();
          this.newArticle.updateDT = getTimeStamp();
          this.newArticle.userId = localStorage.getItem('userId');
          this.newArticle.like = 0;
          this.newArticle.unLike = 0;
          firebase
            .database()
            .ref('article/')
            .push(this.newArticle);
          this.$router.push({ name: 'Home' });
          this.$router.push({ name: 'Home', query: { pg: String(1) } });

          firebase
            .database()
            .ref('user')
            .once('value', snapshot => {
              //유저 리스트 불러오기
              snapshot.forEach(childSnapshot => {
                var childData = childSnapshot.val();
                this.newPostPush('https://fcm.googleapis.com/fcm/send', childData); //백그라운드
              });
            });
          this.newArticle = {};
        }
      }
    },
    newPostPush(url, token) {
      const message = {
        notification: {
          body: '새로운 게시글이 등록되었습니다',
          title: '마음의 소리',
          // "icon": "maxst-logo.png",
          click_action: 'https://voice-of-maxst.firebaseapp.com',
        },
        to: token,
      };
      fetch(url, {
        method: 'POST',
        body: JSON.stringify(message),
        headers: new Headers({
          'Content-type': 'application/json',
          // 'Authorization': 'key=AAAAQeYL0LE:APA91bEsNgjnX2QbogwvPxB5TN9K7eujE1IOU5-MYPPiGgvgNTr-6dEaO1z0KqtpBe-tHnfY9-X_AzMzKz1aB9GF5niU89vRCYtdj64mmQfbo1usR8Dy-EMcRyvUr-hvUBrqX6WubrfF'
          Authorization:
            'key=AAAAk9AA7y8:APA91bExjMQrMQsMdUJFghikTWE4I_2Qsb38V6PfZxjDhU3lKK6oNqlFr2lCCaljc7Yt2h1UTk438keq7vpo1CEudWm6jZONzJ_ldl9VPOMImPT8pPEKrklg643r6TWeZgUJ0vbESGpY',
        }),
      })
        .then(response => {
          if (response.status < 200 || response.status >= 400) {
            throw 'Error subscribing to topic: ' + response.status + ' - ' + response.text();
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    alterArticle: function() {
      if (this.article.content == '' || this.article.content == undefined) this.show = true;
      else {
        if (this.article.content.length > 1000) {
          this.show2 = true;
        } else {
          firebase
            .database()
            .ref('article/')
            .child(this.article.id)
            .update({
              content: this.article.content,
              updateDT: getTimeStamp(),
            });
          this.$router.go(-1);
        }
      }
    },
    backtoArticle() {
      this.$router.go(-1);
    },
    gotoList() {
      this.newArticle = {};
      this.$router.push({ name: 'Home', query: { pg: String(1) } });
    },
    // async getIpClient() {
    //   try {
    //     const response = await axios.get('https://api.ipify.org?format=json');
    //     if (response.data.ip !== '121.134.136.28' && response.data.ip !== '125.131.77.43') {
    //       await this.$router.push({ name: 'NotAccess' });
    //     }
    //   } catch (error) {
    //     console.error(error);
    //   }
    // },
  },
};
</script>

<style scoped>
@import 'Create.scss';
</style>
